"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1882],{

/***/ 59365:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgSignupDecorationRight = function SvgSignupDecorationRight(props) {
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 61,
        height: 77,
        viewBox: "0 0 61 77"
    }, props), _g || (_g = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("g", {
        fill: "#333",
        fillRule: "evenodd",
        transform: "matrix(-1 0 0 1 47 9)"
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 6,
        height: 22,
        x: 20.731,
        y: -2.068,
        rx: 3,
        transform: "rotate(-55 23.731 8.932)"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 6,
        height: 22,
        x: 8.098,
        y: 18.547,
        rx: 3,
        transform: "rotate(-88 11.098 29.547)"
    }), /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
        width: 6,
        height: 24,
        x: 20.766,
        y: 39.068,
        rx: 3,
        transform: "rotate(-122 23.766 51.068)"
    }))));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgSignupDecorationRight);


/***/ }),

/***/ 21882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ TopBarNewComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/url.js
var url = __webpack_require__(8339);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/links.js + 20 modules
var links = __webpack_require__(27639);
;// CONCATENATED MODULE: ./constants/topbar-selectors.js
var TOPBAR_LOGIN_BUTTON_CLASS = "topbar-login-button-class";

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/lodash.throttle/index.js
var lodash_throttle = __webpack_require__(93096);
var lodash_throttle_default = /*#__PURE__*/__webpack_require__.n(lodash_throttle);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/core/social-share-buttons/social-share-buttons-component.scss.js




var StyledSocialShareButtonsComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "egi44rf0"
})("display:flex;align-items:flex-end;&.horizontal{height:40px;padding:0 24px;}&.vertical{flex-direction:column;align-items:flex-start;}&.blog-style{z-index:", z_index/* TOP_BAR */.sE, ";position:fixed;top:50%;left:0;transform:translateY(-50%);.share-button-container{padding:0;margin-bottom:1px;min-width:52px;min-height:55px;position:relative;@media (max-width:", vp_sizes/* TABLET_QUERY_MIN_WIDTH */.Al, "){min-width:22px;min-height:25px;}// Keep icons white on hover\n      svg{top:50%;left:50%;transform:translate(-50%,-50%);position:absolute;path{&:first-child{fill:", colors/* default.white */.Z.white, ";}}}transition:margin 0.2s;&:hover{margin-left:3px;&.facebook-share{background-color:#008fcc;}}&.twitter-share{background-color:#61caf7;}&.facebook-share{background-color:#00a1e5;}&.linkedin-share{background-color:#0086c3;}}}.share-button-container{padding:8px;cursor:pointer;}&.black{.share-button-container:not(:hover){path{&:first-child{fill:", colors/* default.black */.Z.black, ";}}}}&.white{.share-button-container:not(:hover){path{&:first-child{fill:", colors/* default.white */.Z.white, ";}}}}&.scroll-mode:not(.blog-style){.share-button-container:not(:hover){path{&:first-child{fill:", colors/* default.black */.Z.black, ";}}}}");

;// CONCATENATED MODULE: ./static/svg/social-share/share-facebook.svg
var _g;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgShareFacebook = function SvgShareFacebook(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 13,
        height: 22,
        viewBox: "0 0 13 22"
    }, props), _g || (_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#3B5997",
        fillRule: "nonzero",
        d: "M12.204 6.843H8.292V5.097c0-.822.544-1.013.927-1.013h2.74V.47L7.99.458c-3.6 0-4.282 2.694-4.282 4.419v1.965H.958v3.667h2.75v11h4.584v-11h3.53z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M-5 0h22v22H-5z"
    }))));
};
/* harmony default export */ var share_facebook = (SvgShareFacebook);

;// CONCATENATED MODULE: ./static/svg/social-share/share-twitter.svg
var share_twitter_g;
function share_twitter_extends() {
    share_twitter_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return share_twitter_extends.apply(this, arguments);
}

var SvgShareTwitter = function SvgShareTwitter(props) {
    return /*#__PURE__*/ react.createElement("svg", share_twitter_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 17,
        viewBox: "0 0 21 17"
    }, props), share_twitter_g || (share_twitter_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#1DA1F2",
        fillRule: "nonzero",
        d: "M20.49 2.431c-.746.333-1.375.344-2.041.015.86-.515.9-.877 1.21-1.85a8.3 8.3 0 0 1-2.646 1.011 4.166 4.166 0 0 0-7.098 3.8A11.82 11.82 0 0 1 1.33 1.054 4.165 4.165 0 0 0 2.62 6.615a4.15 4.15 0 0 1-1.886-.52v.052a4.17 4.17 0 0 0 3.342 4.085 4.2 4.2 0 0 1-1.882.072 4.17 4.17 0 0 0 3.891 2.892 8.38 8.38 0 0 1-6.167 1.725 11.8 11.8 0 0 0 6.385 1.87c7.662 0 11.85-6.346 11.85-11.85q.001-.272-.01-.54c.813-.587 1.79-1.134 2.348-1.97"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M-1-2h22v22H-1z"
    }))));
};
/* harmony default export */ var share_twitter = (SvgShareTwitter);

;// CONCATENATED MODULE: ./static/svg/social-share/share-linkedin.svg
var share_linkedin_g;
function share_linkedin_extends() {
    share_linkedin_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return share_linkedin_extends.apply(this, arguments);
}

var SvgShareLinkedin = function SvgShareLinkedin(props) {
    return /*#__PURE__*/ react.createElement("svg", share_linkedin_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 20,
        viewBox: "0 0 21 20"
    }, props), share_linkedin_g || (share_linkedin_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        fill: "#0678B5",
        fillRule: "nonzero",
        d: "M5.255 19.604H.463V7.146h4.792zM2.851 5.23h-.03C1.375 5.23.438 4.096.438 2.852.437 1.578 1.403.54 2.878.54c1.477 0 2.385 1.071 2.414 2.345 0 1.245-.937 2.344-2.441 2.344m11.029 5.75a1.917 1.917 0 0 0-1.917 1.917v6.708H7.172s.056-11.5 0-12.458h4.791v1.423s1.484-1.383 3.774-1.383c2.839 0 4.851 2.055 4.851 6.041v6.377h-4.791v-6.708a1.917 1.917 0 0 0-1.917-1.917"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M-1-1h23v23H-1z"
    }))));
};
/* harmony default export */ var share_linkedin = (SvgShareLinkedin);

;// CONCATENATED MODULE: ./static/svg/social-share/stories/stories-share-facebook.svg
var stories_share_facebook_g;
function stories_share_facebook_extends() {
    stories_share_facebook_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return stories_share_facebook_extends.apply(this, arguments);
}

var SvgStoriesShareFacebook = function SvgStoriesShareFacebook(props) {
    return /*#__PURE__*/ react.createElement("svg", stories_share_facebook_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24"
    }, props), stories_share_facebook_g || (stories_share_facebook_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        d: "M17.768 7.5H13.5V5.595c0-.896.594-1.105 1.012-1.105H17.5V.548L13.171.535C9.244.535 8.5 3.473 8.5 5.355V7.5h-3v4h3v12h5v-12h3.851z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M-1 0h24v24H-1z"
    }))));
};
/* harmony default export */ var stories_share_facebook = (SvgStoriesShareFacebook);

;// CONCATENATED MODULE: ./static/svg/social-share/stories/stories-share-twitter.svg
var stories_share_twitter_g;
function stories_share_twitter_extends() {
    stories_share_twitter_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return stories_share_twitter_extends.apply(this, arguments);
}

var SvgStoriesShareTwitter = function SvgStoriesShareTwitter(props) {
    return /*#__PURE__*/ react.createElement("svg", stories_share_twitter_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24"
    }, props), stories_share_twitter_g || (stories_share_twitter_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        d: "M23.407 5.334c-.814.363-1.5.375-2.228.016.938-.562.981-.957 1.32-2.019-.878.521-1.851.9-2.886 1.104a4.545 4.545 0 0 0-7.742 4.145 12.9 12.9 0 0 1-9.366-4.748 4.5 4.5 0 0 0-.615 2.285c0 1.577.803 2.967 2.021 3.782a4.5 4.5 0 0 1-2.057-.568l-.001.057a4.55 4.55 0 0 0 3.646 4.456 4.6 4.6 0 0 1-2.053.079 4.55 4.55 0 0 0 4.245 3.155 9.14 9.14 0 0 1-6.728 1.881A12.87 12.87 0 0 0 7.929 21c8.358 0 12.928-6.924 12.928-12.929q0-.296-.012-.588c.886-.64 1.953-1.237 2.562-2.149Z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M0 .5h24v24H0z"
    }))));
};
/* harmony default export */ var stories_share_twitter = (SvgStoriesShareTwitter);

;// CONCATENATED MODULE: ./static/svg/social-share/stories/stories-share-linkedin.svg
var stories_share_linkedin_g;
function stories_share_linkedin_extends() {
    stories_share_linkedin_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return stories_share_linkedin_extends.apply(this, arguments);
}

var SvgStoriesShareLinkedin = function SvgStoriesShareLinkedin(props) {
    return /*#__PURE__*/ react.createElement("svg", stories_share_linkedin_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        viewBox: "0 0 24 24"
    }, props), stories_share_linkedin_g || (stories_share_linkedin_g = /*#__PURE__*/ react.createElement("g", {
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("path", {
        stroke: "#000",
        strokeLinejoin: "round",
        d: "M7 22H2V9h5zM4.49 7h-.029C2.95 7 1.973 5.818 1.973 4.519c0-1.329 1.008-2.412 2.547-2.412 1.541 0 2.488 1.118 2.519 2.447C7.038 5.854 6.061 7 4.49 7ZM16 13a2 2 0 0 0-2 2v7H9s.059-12 0-13h5v1.485s1.548-1.443 3.938-1.443C20.9 9.042 23 11.186 23 15.346V22h-5v-7a2 2 0 0 0-2-2Z"
    }), /*#__PURE__*/ react.createElement("path", {
        d: "M.5.5h24v24H.5z"
    }))));
};
/* harmony default export */ var stories_share_linkedin = (SvgStoriesShareLinkedin);

// EXTERNAL MODULE: ./services/bigbrain-service.js
var bigbrain_service = __webpack_require__(65488);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
;// CONCATENATED MODULE: ./constants/social-share-urls.js
var FACEBOOK_SHARE_URL_PREFIX = "https://www.facebook.com/sharer/sharer.php?u=";
var TWITTER_SHARE_URL_PREFIX = "https://twitter.com/share?url=";
var LINKEDIN_SHARE_URL_PREFIX = "http://www.linkedin.com/shareArticle?mini=true&url=";

;// CONCATENATED MODULE: ./components/core/social-share-buttons/social-share-buttons-component.js


















var SocialShareButtonsComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SocialShareButtonsComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SocialShareButtonsComponent);
    function SocialShareButtonsComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SocialShareButtonsComponent);
        var _this;
        _this = _super.call(this, props);
        _this.shareFacebook = _this.shareFacebook.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.shareTwitter = _this.shareTwitter.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.shareLinkedin = _this.shareLinkedin.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(SocialShareButtonsComponent, [
        {
            key: "sharePage",
            value: function sharePage(urlPrefix, kind) {
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.SOCIAL_SHARE, {
                    kind: kind
                });
                window.open(urlPrefix + document.URL);
            }
        },
        {
            key: "shareFacebook",
            value: function shareFacebook() {
                this.sharePage(FACEBOOK_SHARE_URL_PREFIX, "facebook");
            }
        },
        {
            key: "shareTwitter",
            value: function shareTwitter() {
                this.sharePage(TWITTER_SHARE_URL_PREFIX, "twitter");
            }
        },
        {
            key: "shareLinkedin",
            value: function shareLinkedin() {
                this.sharePage(LINKEDIN_SHARE_URL_PREFIX, "linkedin");
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, direction = _props.direction, color = _props.color, scrollMode = _props.scrollMode, blogStyle = _props.blogStyle, storiesLogos = _props.storiesLogos, className = _props.className, style = _props.style;
                var directionValue = blogStyle ? "vertical" : direction;
                var colorValue = blogStyle ? "white" : color;
                var FacebookLogo = storiesLogos ? stories_share_facebook : share_facebook;
                var TwitterLogo = storiesLogos ? stories_share_twitter : share_twitter;
                var LinkedinLogo = storiesLogos ? stories_share_linkedin : share_linkedin;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSocialShareButtonsComponent, {
                    className: classnames_default()("social-share-buttons-component", directionValue, colorValue, className, {
                        "scroll-mode": scrollMode,
                        "blog-style": blogStyle
                    }),
                    style: style,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "share-button-container facebook-share",
                            onClick: this.shareFacebook,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FacebookLogo, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "share-button-container twitter-share",
                            onClick: this.shareTwitter,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterLogo, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "share-button-container linkedin-share",
                            onClick: this.shareLinkedin,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkedinLogo, {})
                        })
                    ]
                });
            }
        }
    ]);
    return SocialShareButtonsComponent;
}(react.PureComponent);

SocialShareButtonsComponent.defaultProps = {
    direction: "horizontal",
    color: "black",
    stickyMode: false,
    blogStyle: false
};

// EXTERNAL MODULE: ./services/cookies-service.js
var cookies_service = __webpack_require__(67798);
;// CONCATENATED MODULE: ./components/core/top-bar-new/top-bar-base/top-bar-banner/top-bar-banner-component.scss.js



var TopBarBannerComponentStyles = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1jtcs8p0"
})(".top-bar-banner-component{position:fixed;top:0;left:0;right:0;font-weight:300;font-size:0.875rem;height:32px;width:100%;background-color:", colors/* default.black */.Z.black, ";color:", colors/* default.white */.Z.white, ";display:flex;justify-content:center;align-items:center;z-index:", z_index/* TOP_BAR */.sE + 1, ";.banner-text{margin-right:8px;}.banner-signup-button{padding:4px 18px;font-size:0.731rem;}}");

// EXTERNAL MODULE: ./components/core/button/button-component.js + 5 modules
var button_component = __webpack_require__(20776);
// EXTERNAL MODULE: ./components/pages/pricing-page/pricing-modal-signup-component/pricing-modal-signup-component.js + 2 modules
var pricing_modal_signup_component = __webpack_require__(84079);
;// CONCATENATED MODULE: ./components/core/top-bar-new/top-bar-base/top-bar-banner/top-bar-banner-component.js










var TopBarBannerComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TopBarBannerComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TopBarBannerComponent);
    function TopBarBannerComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TopBarBannerComponent);
        var _this;
        _this = _super.call(this, props);
        _this.openSignupModal = _this.openSignupModal.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.closeModalSignupCallback = _this.closeModalSignupCallback.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            signupModalOpen: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(TopBarBannerComponent, [
        {
            key: "openSignupModal",
            value: function openSignupModal() {
                this.setState({
                    signupModalOpen: true
                });
            }
        },
        {
            key: "closeModalSignupCallback",
            value: function closeModalSignupCallback() {
                this.setState({
                    signupModalOpen: false
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var signupModalOpen = this.state.signupModalOpen;
                var bannerText = this.props.bannerText;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBarBannerComponentStyles, {
                    className: "top-bar-banner-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "banner-text",
                            children: bannerText
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(button_component/* default */.Z, {
                            className: "banner-signup-button",
                            size: "sm",
                            onClickCallback: this.openSignupModal,
                            children: "Sign up"
                        }),
                        signupModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(pricing_modal_signup_component/* default */.Z, {
                            closeModalCallback: this.closeModalSignupCallback
                        })
                    ]
                });
            }
        }
    ]);
    return TopBarBannerComponent;
}(react.PureComponent);

TopBarBannerComponent.defaultProps = {
    bannerText: "Black Friday deals waiting inside"
};

// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./components/core/top-bar-new/top-bar-base/top-bar-base-component.scss.js



var StyledTopBarBaseComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("header", {
    target: "ekufc9b0"
})("nav.navbar{position:fixed;display:flex;flex-direction:row;flex-wrap:wrap;width:100vw;padding:12px;z-index:", z_index/* TOP_BAR */.sE, ";transition:padding 0.2s ease-in-out;top:0;left:0;right:0;margin:auto;.top-bar-content{width:100%;justify-content:space-between;align-items:center;display:flex;margin:auto;}&.with-top-bar-banner{top:32px;}&.sticky-mode{position:static;}.logo-wrapper{display:flex;flex:1;.logo-link{display:flex;}}.social-share-buttons-wrapper{align-self:center;}&.scroll-mode:not(.sticky-mode){background-color:", colors/* default.white */.Z.white, " !important;border-bottom-color:", colors/* default.grey */.Z.grey, ";border-bottom-style:solid;border-bottom-width:1px;padding:8px;.logo-wrapper{.homepage-logo{.monday-logo-image{width:167px;}}}}}.navbar-padding{height:65px;&.sticky-mode{display:none;}&.top-banner{height:85px;}}nav.navbar{.homepage-logo{display:inline-flex;align-items:center;padding:0 16px;.monday-logo-image{transition:width 0.2s ease-in-out;width:167px;}}&:not(.scroll-mode){.homepage-logo.light-theme{svg{.text-shapes,.m-shapes{fill:", colors/* default.white */.Z.white, ";}}}.homepage-logo.black-theme{svg{.text-shapes,.m-shapes{fill:", colors/* default.black */.Z.black, ";}}}.homepage-logo.light-color-theme{svg{.text-shapes{fill:", colors/* default.white */.Z.white, ";}}}}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/top-bar-base/top-bar-base-component.js


















var THROTTLE_TIME = 10; //Execute a method only once per THROTTLE_TIME
var SCROLL_MODE_THRESHOLD = 2; //The amount of pixels from the top that will trigger the scrolled mode of the navbar
var TopBarBaseComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TopBarBaseComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TopBarBaseComponent);
    function TopBarBaseComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TopBarBaseComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isInScrollMode: false,
            shouldShowTopBanner: false
        };
        _this.toggleClassAccrodingToScroll = _this.toggleClassAccrodingToScroll.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.throttledToggleClassAccrodingToScroll = lodash_throttle_default()(_this.toggleClassAccrodingToScroll, THROTTLE_TIME, {
            trailing: true
        });
        _this.closeTopBanner = _this.closeTopBanner.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(TopBarBaseComponent, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.toggleClassAccrodingToScroll();
                var _props = this.props, topBanner = _props.topBanner, showMenu = _props.showMenu;
                var topBannerCookie = (0,cookies_service/* getCookie */.ej)(cookies.TOP_BANNER_COOKIE);
                // const shouldShowTopBanner = topBanner && topBanner.show && !topBannerCookie;
                // this.setState({ shouldShowTopBanner });
                window.addEventListener("scroll", this.throttledToggleClassAccrodingToScroll);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                window.removeEventListener("scroll", this.throttledToggleClassAccrodingToScroll);
            }
        },
        {
            key: "toggleClassAccrodingToScroll",
            value: function toggleClassAccrodingToScroll() {
                var isInScrollMode = (window.pageYOffset || document.documentElement.scrollTop) >= SCROLL_MODE_THRESHOLD;
                this.setState({
                    isInScrollMode: isInScrollMode
                });
                this.props.onScrollModeChange && this.props.onScrollModeChange(isInScrollMode);
            }
        },
        {
            key: "closeTopBanner",
            value: function closeTopBanner() {
                this.setState({
                    shouldShowTopBanner: false
                });
            }
        },
        {
            key: "shouldRenderSocialShareButtons",
            value: function shouldRenderSocialShareButtons() {
                var _props = this.props, allowSocialButtons = _props.allowSocialButtons, socialButtonBlogStyle = _props.socialButtonBlogStyle;
                return allowSocialButtons && socialButtonBlogStyle;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, mobileTheme = _props.mobileTheme, theme = _props.theme, showMenu = _props.showMenu, headerBackgroundColor = _props.headerBackgroundColor, stickyMode = _props.stickyMode, allowSocialButtons = _props.allowSocialButtons, socialButtonsColor = _props.socialButtonsColor, socialButtonBlogStyle = _props.socialButtonBlogStyle, className = _props.className, topBanner = _props.topBanner, children = _props.children, isSideNavOpen = _props.isSideNavOpen, maxWidth = _props.maxWidth, sectionRenderer = _props.sectionRenderer;
                var isInScrollMode = this.state.isInScrollMode;
                var shouldShowTopBanner = this.state.shouldShowTopBanner;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopBarBaseComponent, {
                    className: className,
                    children: [
                        shouldShowTopBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBarBannerComponent, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                            className: classnames_default()("navbar", {
                                "scroll-mode": isInScrollMode
                            }, {
                                "slidenav-open": isSideNavOpen
                            }, {
                                "sticky-mode": stickyMode
                            }, {
                                "with-top-bar-banner": shouldShowTopBanner
                            }),
                            style: {
                                backgroundColor: headerBackgroundColor
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "top-bar-content",
                                style: {
                                    maxWidth: maxWidth
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "logo-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/",
                                                className: "logo-link",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classnames_default()("homepage-logo", theme, className, (0,_define_property/* default */.Z)({}, "mobile-".concat(theme), theme)),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                                                        src: links/* MONDAY_LOGO_SRC */.Onk,
                                                        mobile: links/* MONDAY_LOGO_SRC */.Onk,
                                                        className: "monday-logo-image"
                                                    })
                                                })
                                            }),
                                            sectionRenderer && sectionRenderer()
                                        ]
                                    }),
                                    this.shouldRenderSocialShareButtons() && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "social-share-buttons-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShareButtonsComponent, {
                                            scrollMode: isInScrollMode,
                                            direction: "horizontal",
                                            color: socialButtonsColor,
                                            blogStyle: socialButtonBlogStyle
                                        })
                                    }),
                                    showMenu && children
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: classnames_default()("navbar-padding", {
                                "sticky-mode": stickyMode,
                                "top-banner": shouldShowTopBanner
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return TopBarBaseComponent;
}(react.PureComponent);

TopBarBaseComponent.defaultProps = {
    url: "//auth.monday.com/login",
    headerBackgroundColor: "white",
    stickyMode: false,
    allowSocialButtons: false,
    socialButtonsColor: "black",
    socialButtonBlogStyle: false,
    maxWidth: "".concat(vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px")
};

// EXTERNAL MODULE: ./components/enhancements/spinner/spinner-component.js + 1 modules
var spinner_component = __webpack_require__(79067);
;// CONCATENATED MODULE: ./components/core/top-bar-new/outline-button/outline-button-component.scss.js


var StyledOutlineButtonComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eczjcxp0"
})("&.default{&:hover a{background-color:", colors/* default.black */.Z.black, ";color:", colors/* default.white */.Z.white, ";}a{position:relative;display:block;border:1px solid ", colors/* default.black */.Z.black, ";color:", colors/* default.black */.Z.black, ";padding:7px 18px;font-size:0.875rem;vertical-align:middle;text-align:center;text-decoration:none;font-weight:300;&.loading{cursor:default;}.content{&.loading{opacity:0;}}}&.scroll-mode{a{padding:8px 16px;}}&.light-theme:not(.scroll-mode){a{color:", colors/* default.white */.Z.white, ";border-color:", colors/* default.white */.Z.white, ";}&:hover a{color:", colors/* default.light-blue */.Z["light-blue"], ";background-color:", colors/* default.white */.Z.white, ";}}}&.circled{&:hover a{background-color:", colors/* default.black */.Z.black, ";color:", colors/* default.white */.Z.white, ";border-width:1px;border-style:solid;border-color:", colors/* default.black */.Z.black, ";}a{display:block;border:1px solid ", colors/* default.black */.Z.black, ";border-radius:24px;color:", colors/* default.black */.Z.black, ";padding:8px 24px;font-size:1rem;vertical-align:middle;text-align:center;text-decoration:none;font-weight:300;}&.scroll-mode{a{padding:8px 16px;}}&.light-theme:not(.scroll-mode){a{color:", colors/* default.white */.Z.white, ";border-color:", colors/* default.white */.Z.white, ";}&:hover a{color:", colors/* default.light-blue */.Z["light-blue"], ";background-color:", colors/* default.white */.Z.white, ";}}}&.textual{&:hover a{text-decoration:none;}a{display:block;color:", colors/* default.black */.Z.black, ";padding:10px 0;font-size:1rem;vertical-align:middle;text-align:center;text-decoration:none;font-weight:300;}&.scroll-mode{a{padding:10px 0;}}&.light-theme:not(.scroll-mode){a{color:", colors/* default.white */.Z.white, ";}}}&.default{&:hover a svg{circle{stroke:white;}}a .spinner{position:absolute;left:calc(50% - 12px);top:calc(50% - 12px);}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/outline-button/outline-button-component.js










var OutlineButtonComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OutlineButtonComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OutlineButtonComponent);
    function OutlineButtonComponent(props) {
        (0,_class_call_check/* default */.Z)(this, OutlineButtonComponent);
        var _this;
        _this = _super.call(this, props);
        _this.onClick = _this.onClick.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(OutlineButtonComponent, [
        {
            key: "onClick",
            value: function onClick(e) {
                var onClickCallback = this.props.onClickCallback;
                if (onClickCallback) {
                    onClickCallback(e);
                }
                return true; // continue the location change
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, text = _props.text, url = _props.url, theme = _props.theme, buttonStyle = _props.buttonStyle, isInScrollMode = _props.isInScrollMode, linkClassName = _props.linkClassName, loading = _props.loading, onClickCallback = _props.onClickCallback;
                var scrollModeClass = isInScrollMode ? "scroll-mode" : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOutlineButtonComponent, {
                    className: classnames_default()("outline-button", theme, buttonStyle, scrollModeClass),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: url,
                        className: classnames_default()(linkClassName, {
                            loading: loading
                        }),
                        onClick: this.onClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("content", {
                                    loading: loading
                                }),
                                children: text
                            }),
                            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner_component/* default */.Z, {
                                className: "spinner",
                                color: "black",
                                size: "24px",
                                speed: "slow"
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return OutlineButtonComponent;
}(react.PureComponent);

OutlineButtonComponent.defaultProps = {
    isInScrollMode: false,
    text: "",
    url: undefined,
    theme: "",
    buttonStyle: "default",
    linkClassName: "",
    loading: false
};

;// CONCATENATED MODULE: ./components/core/menu/menu-content/menu-content-component.scss.js


var StyledMenuContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1fqrmuj0"
})("box-shadow:0 2px 16px 0 rgba(0,0,0,0.2);border:1px solid ", colors/* default.light-grey */.Z["light-grey"], ";background-color:", colors/* default.white */.Z.white, ";padding:16px;");

// EXTERNAL MODULE: ./node_modules/react-onclickoutside/dist/react-onclickoutside.es.js
var react_onclickoutside_es = __webpack_require__(58949);
;// CONCATENATED MODULE: ./components/core/menu/menu-content/menu-content-component.js










var MenuContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MenuContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MenuContentComponent);
    function MenuContentComponent(props) {
        (0,_class_call_check/* default */.Z)(this, MenuContentComponent);
        var _this;
        _this = _super.call(this, props);
        _this.handleClickOutside = _this.handleClickOutside.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(MenuContentComponent, [
        {
            key: "handleClickOutside",
            value: function handleClickOutside() {
                var closeMenu = this.props.closeMenu;
                if (closeMenu) closeMenu();
            }
        },
        {
            key: "render",
            value: function render() {
                var style = this.props.style;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenuContentComponent, {
                    className: "menu-content-component",
                    style: style,
                    children: this.props.contentRenderer()
                });
            }
        }
    ]);
    return MenuContentComponent;
}(react.PureComponent);
/* harmony default export */ var menu_content_component = ((0,react_onclickoutside_es/* default */.Z)(MenuContentComponent));

;// CONCATENATED MODULE: ./components/core/menu/menu-component.scss.js

var StyledOutlineButtonWithMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "en6uxov0"
})("position:relative;.button-wrapper{display:inline-flex;align-items:center;}.menu-content-wrapper{position:absolute;}");

;// CONCATENATED MODULE: ./components/core/menu/menu-component.js





function menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            menu_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var OutlineButtonWithMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OutlineButtonWithMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OutlineButtonWithMenuComponent);
    function OutlineButtonWithMenuComponent(props) {
        (0,_class_call_check/* default */.Z)(this, OutlineButtonWithMenuComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            showMenu: false
        };
        _this.showMenu = _this.showMenu.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.hideMenu = _this.hideMenu.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(OutlineButtonWithMenuComponent, [
        {
            key: "showMenu",
            value: function showMenu() {
                this.setState({
                    showMenu: true
                });
            }
        },
        {
            key: "hideMenu",
            value: function hideMenu() {
                this.setState({
                    showMenu: false
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, buttonLink = _props.buttonLink, menu = _props.menu, className = _props.className, buttonRenderer = _props.buttonRenderer;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOutlineButtonWithMenuComponent, {
                    className: "menu-component ".concat(className),
                    onMouseEnter: this.showMenu,
                    onMouseLeave: this.hideMenu,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "button-wrapper",
                            children: buttonRenderer && buttonRenderer()
                        }),
                        this.state.showMenu && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "menu-content-wrapper",
                            style: menu.style,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_content_component, _object_spread({}, menu))
                        })
                    ]
                });
            }
        }
    ]);
    return OutlineButtonWithMenuComponent;
}(react.PureComponent);

OutlineButtonWithMenuComponent.defaultProps = {
    menu: {},
    buttonLink: {}
};

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./components/core/top-bar-new/desktop/top-bar-desktop-link-with-menu/top-bar-desktop-link-with-menu-component.scss.js


var StylesMenuItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1a1decy0"
})(".menu-links-items{display:flex;}.menu-links{display:flex;flex-direction:column;flex-wrap:wrap;max-height:240px;.menu-link-item{flex:1 1 auto;a{font-size:0.875rem;padding:12px 16px;color:", colors/* default.black */.Z.black, ";white-space:nowrap;text-decoration:none;display:block;}&.selected a{font-weight:500;}&:hover a{color:", function(param) {
    var _hoverColor = param.hoverColor, hoverColor = _hoverColor === void 0 ? "brand-purple" : _hoverColor;
    return colors/* default */.Z[hoverColor];
}, ";}}}.bottom-link{margin:16px;a{color:", colors/* default.black */.Z.black, ";&.selected{font-weight:500;}&:hover{color:", function(param) {
    var _hoverColor = param.hoverColor, hoverColor = _hoverColor === void 0 ? "brand-purple" : _hoverColor;
    return colors/* default */.Z[hoverColor];
}, ";}}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/desktop/top-bar-desktop-link-with-menu/top-bar-desktop-link-with-menu-component.js





function top_bar_desktop_link_with_menu_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function top_bar_desktop_link_with_menu_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            top_bar_desktop_link_with_menu_component_define_property(target, key, source[key]);
        });
    }
    return target;
}







var TopBarDesktopLinkWithMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TopBarDesktopLinkWithMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TopBarDesktopLinkWithMenuComponent);
    function TopBarDesktopLinkWithMenuComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TopBarDesktopLinkWithMenuComponent);
        var _this;
        _this = _super.call(this, props);
        _this.outlineButtonRenderer = _this.outlineButtonRenderer.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.contentRenderer = _this.contentRenderer.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(TopBarDesktopLinkWithMenuComponent, [
        {
            key: "isLinkItemSelected",
            value: function isLinkItemSelected(linkItemText) {
                var activeLinkText = this.props.activeLinkText;
                return linkItemText === activeLinkText;
            }
        },
        {
            key: "contentRenderer",
            value: function contentRenderer() {
                var _this = this;
                var _props = this.props, menuItems = _props.menuItems, hoverColor = _props.hoverColor, translate = _props.translate;
                var menuItemsText = Object.keys(menuItems.links);
                var bottomLinksText = menuItems.bottomLinks ? Object.keys(menuItems.bottomLinks) : [];
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StylesMenuItem, {
                    hoverColor: hoverColor,
                    className: "menu-links-wrapper",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "menu-links-items",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "menu-links",
                                children: menuItemsText.map(function(menuItemText) {
                                    var menuItemUrl = menuItems.links[menuItemText];
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: classnames_default()("menu-link-item", {
                                            selected: _this.isLinkItemSelected(menuItemText)
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            href: menuItemUrl,
                                            children: translate(menuItemText)
                                        })
                                    }, menuItemText);
                                })
                            })
                        }),
                        bottomLinksText.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bottom-link",
                            children: bottomLinksText.map(function(buttomLinkText) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    className: classnames_default()("button-link-item", {
                                        selected: _this.isLinkItemSelected(buttomLinkText)
                                    }),
                                    href: menuItems.bottomLinks[buttomLinkText],
                                    children: translate(buttomLinkText)
                                }, buttomLinkText);
                            })
                        })
                    ]
                });
            }
        },
        {
            key: "outlineButtonRenderer",
            value: function outlineButtonRenderer() {
                var _props = this.props, button = _props.button, children = _props.children;
                return children ? children : /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlineButtonComponent, top_bar_desktop_link_with_menu_component_object_spread({}, button));
            }
        },
        {
            key: "render",
            value: function render() {
                var menuProps = {
                    contentRenderer: this.contentRenderer
                };
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "top-bar-desktop-menu-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlineButtonWithMenuComponent, {
                        buttonRenderer: this.outlineButtonRenderer,
                        menu: menuProps
                    })
                });
            }
        }
    ]);
    return TopBarDesktopLinkWithMenuComponent;
}(react.PureComponent);
/* harmony default export */ var top_bar_desktop_link_with_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(TopBarDesktopLinkWithMenuComponent));

// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
;// CONCATENATED MODULE: ./components/core/top-bar-new/desktop/topbar-login-signup/topbar-login-signup-component.scss.js


var StyledTopbarLoginSignupComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "esfr53k0"
})("display:flex;.topbar-login-signup-seperator{width:1px;margin-right:24px;background-color:#e3e3e3;}.topbar-login-signup-login-button-wrapper{margin-right:16px;.outline-button{a.login-top-bar{div.content{font-weight:400;font-size:0.875rem;}&:hover{color:", colors/* default.brand-purple */.Z["brand-purple"], ";}}}}.topbar-login-signup-base-signup-wrapper{display:flex;align-items:center;.signup-form-component{.signup-input{padding:10px 19px;min-width:auto;max-width:160px;border-radius:4px;margin:0 8px;}.signup-button{padding:10px 19px;}}}@media (max-width:1124px){.topbar-login-signup-base-signup-wrapper{display:none;}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/desktop/topbar-login-signup/topbar-login-signup-component.js




function topbar_login_signup_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function topbar_login_signup_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            topbar_login_signup_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var TopbarLoginSignupComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TopbarLoginSignupComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TopbarLoginSignupComponent);
    function TopbarLoginSignupComponent() {
        (0,_class_call_check/* default */.Z)(this, TopbarLoginSignupComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TopbarLoginSignupComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, loginUrl = _props.loginUrl, theme = _props.theme, isInScrollMode = _props.isInScrollMode, signupTrackingPlacement = _props.signupTrackingPlacement, translate = _props.translate, buttonText = _props.buttonText, inputPlaceholder = _props.inputPlaceholder;
                var buttonTextToUse = buttonText || translate("signup.signup");
                var inputPlaceholderToUse = inputPlaceholder || translate("signup.emailInputShortPlaceholder");
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarLoginSignupComponent, {
                    className: "topbar-login-signup-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "topbar-login-signup-seperator"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "topbar-login-signup-login-button-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlineButtonComponent, {
                                url: loginUrl || links/* LOGIN_PAGE_LINK */.dVh,
                                text: translate("signup.logIn"),
                                theme: theme,
                                isInScrollMode: isInScrollMode,
                                buttonStyle: "textual",
                                linkClassName: "".concat(TOPBAR_LOGIN_BUTTON_CLASS, " login-top-bar")
                            })
                        }),
                        isInScrollMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "topbar-login-signup-base-signup-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, _object_spread_props(topbar_login_signup_component_object_spread({}, this.props), {
                                ctaText: buttonTextToUse,
                                useCtaText: !!buttonTextToUse,
                                inputPlaceholder: inputPlaceholderToUse,
                                preventErrorMessage: true,
                                placement: signupTrackingPlacement
                            }))
                        })
                    ]
                });
            }
        }
    ]);
    return TopbarLoginSignupComponent;
}(react.PureComponent);
TopbarLoginSignupComponent.defaultProps = {
    signupTrackingPlacement: "topbar"
};
/* harmony default export */ var topbar_login_signup_component = ((0,generic_config_context/* withGenericConfig */.P)(TopbarLoginSignupComponent));

;// CONCATENATED MODULE: ./components/core/top-bar-new/desktop/top-bar-desktop-component.scss.js


var StyledTopbarDesktopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ekb33970"
})("display:flex;align-self:center;.top-header-link-wrapper,.top-header-login-link-wrapper{margin-left:24px;.outline-button.textual{a.top-bar-link{div.content{font-weight:400;font-size:0.875rem;}}&:hover a.top-bar-link{text-decoration:none;}&:not(:hover) a.top-bar-link{transition:0.2s ease all;}}}.top-header-login-link-wrapper{.outline-button.circled a.login-top-bar{font-size:0.875rem;}.outline-button.circled:hover a.login-top-bar{border-color:", colors/* default.brand-purple */.Z["brand-purple"], ";background-color:transparent;color:", colors/* default.brand-purple */.Z["brand-purple"], ";}}.topbar-login-signup-wrapper{margin-left:24px;}.topbar-language-picker-wrapper{width:50px;margin-left:16px;}.outline-button-header-link-wrapper{.outline-button.textual a.selected,.outline-button.textual a:hover{color:", colors/* default.dark-indigo */.Z["dark-indigo"], ";}}");
var StyledMenu = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ekb33971"
})(".menu-content-wrapper{padding-top:8px;}.use-cases{.menu-content-component{width:420px;padding:16px;}}");

// EXTERNAL MODULE: ./services/localization/localization-service.js
var localization_service = __webpack_require__(99952);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
;// CONCATENATED MODULE: ./components/core/top-bar-new/desktop/top-bar-desktop-component.js





function top_bar_desktop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function top_bar_desktop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            top_bar_desktop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function top_bar_desktop_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function top_bar_desktop_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        top_bar_desktop_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
















var POSSIBLE_HOVER_COLORS = [
    "brand-purple",
    "brand-green",
    "brand-pink",
    "brand-blue"
];
var TopbarDesktopComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TopbarDesktopComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TopbarDesktopComponent);
    function TopbarDesktopComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TopbarDesktopComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isInScrollMode: false
        };
        _this.onScrollModeChange = _this.onScrollModeChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.renderHeaderLink = _this.renderHeaderLink.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(TopbarDesktopComponent, [
        {
            key: "onScrollModeChange",
            value: function onScrollModeChange(isInScrollMode) {
                this.setState({
                    isInScrollMode: isInScrollMode
                });
            }
        },
        {
            key: "getLinkClassName",
            value: function getLinkClassName(headerLink) {
                var _props = this.props, _router = _props.router, router = _router === void 0 ? {} : _router;
                var selected = headerLink.menuLinks ? !!this.getMenuLinkActiveLinkText(headerLink) : (0,url.sameUrls)(headerLink, router.asPath);
                return classnames_default()("top-bar-link", {
                    selected: selected
                });
            }
        },
        {
            key: "getMenuLinkActiveLinkText",
            value: function getMenuLinkActiveLinkText(headerLinkMenu) {
                var _props = this.props, _router = _props.router, router = _router === void 0 ? {} : _router;
                var _menuLinks = headerLinkMenu.menuLinks, links = _menuLinks.links, bottomLinks = _menuLinks.bottomLinks;
                var allLinks = top_bar_desktop_component_object_spread({}, links, bottomLinks);
                var activeLinkText = null;
                Object.keys(allLinks).forEach(function(linkText) {
                    if ((0,url.sameUrls)(allLinks[linkText], router.asPath)) activeLinkText = linkText;
                });
                return activeLinkText;
            }
        },
        {
            key: "renderLinkWithMenu",
            value: function renderLinkWithMenu(headerLinkText, headerLinkMenu, hoverColor) {
                var localeId = this.props.localeId;
                var className = headerLinkMenu.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledMenu, {
                    className: "".concat(className, " topbar-menu-wrapper"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_desktop_link_with_menu_component, {
                        menuItems: headerLinkMenu.menuLinks,
                        hoverColor: hoverColor,
                        localeId: localeId,
                        children: this.renderLink(headerLinkText, headerLinkMenu, hoverColor)
                    })
                });
            }
        },
        {
            key: "getLinkUrl",
            value: function getLinkUrl(headerLink) {
                return headerLink.menuLinks ? undefined : headerLink;
            }
        },
        {
            key: "renderLink",
            value: function renderLink(headerLinkText, headerLink, hoverColor) {
                var _props = this.props, theme = _props.theme, isInScrollMode = _props.isInScrollMode, translate = _props.translate;
                var linkUrl = this.getLinkUrl(headerLink);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "outline-button-header-link-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlineButtonComponent, {
                        url: linkUrl,
                        text: translate(headerLinkText),
                        theme: theme,
                        isInScrollMode: isInScrollMode,
                        buttonStyle: "textual",
                        linkClassName: this.getLinkClassName(headerLink)
                    })
                });
            }
        },
        {
            key: "getHeaderLinks",
            value: function getHeaderLinks() {
                var _props = this.props, desktopHeaderLinks = _props.desktopHeaderLinks, shortHeader = _props.shortHeader, localeId = _props.localeId;
                return desktopHeaderLinks ? desktopHeaderLinks : (0,localization_service/* getHeaderComponents */.am)(localeId, shortHeader);
            }
        },
        {
            key: "renderHeaderLink",
            value: function renderHeaderLink(headerLinkText, index) {
                var header = this.getHeaderLinks();
                var headerLink = header.links[headerLinkText];
                if (!headerLink) return null;
                var color = POSSIBLE_HOVER_COLORS[index % POSSIBLE_HOVER_COLORS.length];
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "top-header-link-wrapper",
                    children: headerLink.menuLinks ? this.renderLinkWithMenu(headerLinkText, headerLink, color) : this.renderLink(headerLinkText, headerLink, color)
                }, headerLinkText);
            }
        },
        {
            key: "renderLoginLink",
            value: function renderLoginLink() {
                var _props = this.props, theme = _props.theme, isInScrollMode = _props.isInScrollMode, loginUrl = _props.loginUrl, translate = _props.translate;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "top-header-login-link-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlineButtonComponent, {
                        url: loginUrl || links/* LOGIN_PAGE_LINK */.dVh,
                        text: translate("signup.logIn"),
                        theme: theme,
                        isInScrollMode: isInScrollMode,
                        buttonStyle: "circled",
                        linkClassName: "".concat(TOPBAR_LOGIN_BUTTON_CLASS, " login-top-bar")
                    })
                });
            }
        },
        {
            key: "renderLoginSignupComponentWithSeperator",
            value: function renderLoginSignupComponentWithSeperator() {
                var isInScrollMode = this.state.isInScrollMode;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "topbar-login-signup-wrapper",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(topbar_login_signup_component, {
                        isInScrollMode: isInScrollMode
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var header = this.getHeaderLinks();
                var headerLinksText = Object.keys(header.links);
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TopBarBaseComponent, top_bar_desktop_component_object_spread_props(top_bar_desktop_component_object_spread({}, this.props), {
                    onScrollModeChange: this.onScrollModeChange,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopbarDesktopComponent, {
                        className: "navbar-menu",
                        children: [
                            headerLinksText.map(this.renderHeaderLink),
                            this.renderLoginLink()
                        ]
                    })
                }));
            }
        }
    ]);
    return TopbarDesktopComponent;
}(react.PureComponent);
TopbarDesktopComponent.defaultProps = {
    stickyMode: false,
    allowSocialButtons: false,
    socialButtonsColor: "black",
    socialButtonBlogStyle: false,
    translate: function(key) {
        return key;
    }
};
/* harmony default export */ var top_bar_desktop_component = ((0,ab_tests_context/* withAbTests */.k)((0,generic_config_context/* withGenericConfig */.P)((0,router.withRouter)(TopbarDesktopComponent))));

// EXTERNAL MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.js + 1 modules
var hamburger_menu_component = __webpack_require__(73418);
;// CONCATENATED MODULE: ./components/core/top-bar-new/mobile/side-menu/side-menu-mobile/side-menu-mobile-component.scss.js




var StyledSideMenuMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eagnaaa0"
})("width:100vw;height:100vh;position:absolute;top:65px;left:0;display:flex;justify-content:center;transition:top 0.1s ease-in-out,opacity 0.1s ease-in-out;opacity:0;z-index:", z_index/* HIDDEN */.A1, ";transform:translate(-100%);&.open{transform:translate(0);opacity:1;z-index:", z_index/* ZERO */.xE, ";.side-menu-mobile-dialog{opacity:1;}}&.scroll-mode{top:58px;}.side-menu-mobile-dialog{width:100%;height:100%;top:0;left:0;background:", colors/* default.brand-pink */.Z["brand-pink"], ";z-index:", z_index/* MODAL_BACKGROUND */.AE + 1, ";align-self:center;section.links-section{display:flex;flex-direction:column;align-items:center;justify-content:center;margin-top:24px;a{margin:16px 0;display:block;color:", colors/* default.white */.Z.white, ";font-weight:300;text-decoration:none;font-size:2.25rem;}}section.buttom-bottons{display:flex;justify-content:center;align-items:center;margin-top:24px;.download-app-wrapper{cursor:pointer;}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH_M */.TI, "){.side-menu-mobile-dialog{section.links-section{align-items:center;a{font-size:1.375rem;margin:8px 0;}}}}.side-menu-mobile-dialog{section.buttom-bottons{.download-app-wrapper{margin:0 8px;img{width:45vw;max-width:200px;}}.decoration svg{width:40px;rect{fill:", colors/* default.white */.Z.white, ";}}}}");

// EXTERNAL MODULE: ./utils/mobile.js
var mobile = __webpack_require__(34955);
;// CONCATENATED MODULE: ./static/svg/decorators/signup/signup-decoration-left.svg
var signup_decoration_left_g;
function signup_decoration_left_extends() {
    signup_decoration_left_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return signup_decoration_left_extends.apply(this, arguments);
}

var SvgSignupDecorationLeft = function SvgSignupDecorationLeft(props) {
    return /*#__PURE__*/ react.createElement("svg", signup_decoration_left_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 61,
        height: 77,
        viewBox: "0 0 61 77"
    }, props), signup_decoration_left_g || (signup_decoration_left_g = /*#__PURE__*/ react.createElement("g", {
        fill: "#333",
        fillRule: "evenodd"
    }, /*#__PURE__*/ react.createElement("rect", {
        width: 6,
        height: 22,
        x: 31.731,
        y: 6.932,
        rx: 3,
        transform: "rotate(-55 34.731 17.932)"
    }), /*#__PURE__*/ react.createElement("rect", {
        width: 6,
        height: 22,
        x: 19.098,
        y: 27.547,
        rx: 3,
        transform: "rotate(-88 22.098 38.547)"
    }), /*#__PURE__*/ react.createElement("rect", {
        width: 6,
        height: 24,
        x: 31.766,
        y: 48.068,
        rx: 3,
        transform: "rotate(-122 34.766 60.068)"
    }))));
};
/* harmony default export */ var signup_decoration_left = (SvgSignupDecorationLeft);

// EXTERNAL MODULE: ./static/svg/decorators/signup/signup-decoration-right.svg
var signup_decoration_right = __webpack_require__(59365);
;// CONCATENATED MODULE: ./components/core/top-bar-new/mobile/side-menu/side-menu-mobile/side-menu-mobile-component.js




















var SideMenuMobileComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SideMenuMobileComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SideMenuMobileComponent);
    function SideMenuMobileComponent(props) {
        (0,_class_call_check/* default */.Z)(this, SideMenuMobileComponent);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            isAndroidPhone: false
        };
        _this.downloadMobileApp = _this.downloadMobileApp.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(SideMenuMobileComponent, [
        {
            key: "downloadMobileApp",
            value: function downloadMobileApp() {
                var isAndroidPhone = this.state.isAndroidPhone;
                BigBrain("track", "hp_store_clicked", {
                    kind: isAndroidPhone ? "andriod" : "ios"
                });
                window.location.href = isAndroidPhone ? links/* ANDROID_APP_DOWNLOAD_LINK */.Je_ : links/* IOS_APP_DOWNLOAD_LINK */.XYT;
            }
        },
        {
            key: "trackLinkClick",
            value: function trackLinkClick(event) {
                var target = event.target;
                var href = (0,url.normalizeUrl)(target.href);
                (0,bigbrain_service.trackEvent)(bigbrain_event_types.SIDE_MENU_LINK_CLICK, {
                    kind: href,
                    placement: "mobile"
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    isAndroidPhone: (0,mobile/* isAndroid */.Dt)()
                });
            }
        },
        {
            key: "renderAppButton",
            value: function renderAppButton() {
                var isAndroidPhone = this.state.isAndroidPhone;
                var imgSrc = isAndroidPhone ? "/static/img/apps/google_play.png" : "/static/img/apps/app_store.png";
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, {
                    src: imgSrc
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, open = _props.open, scrollMode = _props.scrollMode, translate = _props.translate, mobileHeaderLinks = _props.mobileHeaderLinks;
                var header = mobileHeaderLinks;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideMenuMobileComponent, {
                    className: classnames_default()("side-menu-mobile", {
                        open: open,
                        "scroll-mode": scrollMode
                    }),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "side-menu-mobile-dialog",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "links-section",
                                children: Object.keys(header.links).map(function(title) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "side-nav-link-wrapper",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OutlineButtonComponent, {
                                            url: header.links[title],
                                            text: translate(title),
                                            buttonStyle: "textual",
                                            linkClassName: "side-nav-link"
                                        })
                                    }, title);
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                className: "buttom-bottons",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "left-decoration decoration",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_decoration_left, {}, "left-decoration decoration")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "download-app-wrapper",
                                        onClick: this.downloadMobileApp,
                                        children: this.renderAppButton()
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "right-decoration decoration",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_decoration_right/* default */.Z, {}, "right-decoration")
                                    })
                                ]
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return SideMenuMobileComponent;
}(react.PureComponent);
SideMenuMobileComponent.defaultProps = {
    open: false,
    mobileHeaderLinks: links/* SideMenuMobile */.muo
};
/* harmony default export */ var side_menu_mobile_component = ((0,generic_config_context/* withGenericConfig */.P)(SideMenuMobileComponent));

;// CONCATENATED MODULE: ./components/core/top-bar-new/mobile/side-menu/side-menu-component.js







var SideMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SideMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SideMenuComponent);
    function SideMenuComponent() {
        (0,_class_call_check/* default */.Z)(this, SideMenuComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SideMenuComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, isOpen = _props.isOpen, scrollMode = _props.scrollMode, mobileHeaderLinks = _props.mobileHeaderLinks;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(side_menu_mobile_component, {
                    open: isOpen,
                    scrollMode: scrollMode,
                    mobileHeaderLinks: mobileHeaderLinks
                });
            }
        }
    ]);
    return SideMenuComponent;
}(react.PureComponent);

SideMenuComponent.defaultProps = {
    isOpen: false
};

;// CONCATENATED MODULE: ./components/core/top-bar-new/mobile/top-bar-mobile-component.scss.js



var StyledTopbarMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e15nbowv0"
})("@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){nav.navbar,nav.navbar.scroll-mode{padding:12px 8px;.logo-wrapper{.homepage-logo{padding:0 8px;svg{width:167px;}}}}.navbar-padding{height:54px;}.social-share-buttons-wrapper{display:none;}nav.navbar:not(.scroll-mode){.homepage-logo.mobile-light-theme{svg{ellipse,path{fill:", colors/* default.white */.Z.white, ";}}}.homepage-logo.mobile-black-theme{svg{ellipse,path{fill:", colors/* default.black */.Z.black, ";}}}}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/mobile/top-bar-mobile-component.js





function top_bar_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function top_bar_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            top_bar_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function top_bar_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function top_bar_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        top_bar_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var TopbarMobileComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TopbarMobileComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TopbarMobileComponent);
    function TopbarMobileComponent(props) {
        (0,_class_call_check/* default */.Z)(this, TopbarMobileComponent);
        var _this;
        _this = _super.call(this, props);
        _this.toggleSlideNavState = _this.toggleSlideNavState.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onScrollModeChange = _this.onScrollModeChange.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = {
            isSideNavOpen: false,
            isInScrollMode: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(TopbarMobileComponent, [
        {
            key: "toggleSlideNavState",
            value: function toggleSlideNavState(isSideNavOpen) {
                this.setState({
                    isSideNavOpen: isSideNavOpen
                });
            }
        },
        {
            key: "onScrollModeChange",
            value: function onScrollModeChange(isInScrollMode) {
                this.setState({
                    isInScrollMode: isInScrollMode
                });
            }
        },
        {
            key: "renderHeaderLinks",
            value: function renderHeaderLinks() {
                var _props = this.props, theme = _props.theme, url = _props.url, mobileHeaderLinks = _props.mobileHeaderLinks;
                var _state = this.state, isSideNavOpen = _state.isSideNavOpen, isInScrollMode = _state.isInScrollMode;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "navbar-menu",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(hamburger_menu_component/* default */.Z, {
                            theme: theme,
                            isInScrollMode: isInScrollMode,
                            changeStateCallback: this.toggleSlideNavState,
                            isOpen: isSideNavOpen
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(SideMenuComponent, {
                            isOpen: isSideNavOpen,
                            scrollMode: isInScrollMode,
                            mobileHeaderLinks: mobileHeaderLinks
                        })
                    ]
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTopbarMobileComponent, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBarBaseComponent, top_bar_mobile_component_object_spread_props(top_bar_mobile_component_object_spread({}, this.props), {
                        onScrollModeChange: this.onScrollModeChange,
                        children: [
                            " ",
                            this.renderHeaderLinks()
                        ]
                    }))
                });
            }
        }
    ]);
    return TopbarMobileComponent;
}(react.PureComponent);
TopbarMobileComponent.defaultProps = {
    url: "//auth.monday.com/login",
    headerBackgroundColor: "white",
    stickyMode: false,
    allowSocialButtons: false,
    socialButtonsColor: "black",
    socialButtonBlogStyle: false
};
/* harmony default export */ var top_bar_mobile_component = ((0,generic_config_context/* withGenericConfig */.P)(TopbarMobileComponent));

;// CONCATENATED MODULE: ./components/core/top-bar-new/top-bar-component.scss.js


var StyledTopBarNewComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1vd2gsn0"
})(".top-bar-mobile-wrapper{display:none;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.top-bar-desktop-wrapper{display:none;}.top-bar-mobile-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/top-bar-component.js




function top_bar_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function top_bar_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            top_bar_component_define_property(target, key, source[key]);
        });
    }
    return target;
}





var TopBarNewComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(TopBarNewComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(TopBarNewComponent);
    function TopBarNewComponent() {
        (0,_class_call_check/* default */.Z)(this, TopBarNewComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(TopBarNewComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledTopBarNewComponent, {
                    className: "top-bar-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "top-bar-desktop-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_desktop_component, top_bar_component_object_spread({}, this.props))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "top-bar-mobile-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_mobile_component, top_bar_component_object_spread({}, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return TopBarNewComponent;
}(react.PureComponent);



/***/ }),

/***/ 79067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ SpinnerComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./components/enhancements/spinner/spinner-component.scss.js

var StyledSpinnerComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", {
    target: "e100yrh40"
})("transition-property:transform;animation-name:__svg-spinner_infinite-spin;animation-iteration-count:infinite;animation-timing-function:linear;transform-origin:center;@keyframes __svg-spinner_infinite-spin{from{transform:rotate(0deg);}to{transform:rotate(360deg);}}");

;// CONCATENATED MODULE: ./components/enhancements/spinner/spinner-component.js








var SpinnerComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(SpinnerComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(SpinnerComponent);
    function SpinnerComponent() {
        (0,_class_call_check/* default */.Z)(this, SpinnerComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(SpinnerComponent, [
        {
            key: "speedSwitch",
            value: function speedSwitch(speed) {
                if (speed === "fast") return 600;
                if (speed === "slow") return 900;
                return 750;
            }
        },
        {
            key: "getSpinner",
            value: function getSpinner() {
                var _props = this.props, color = _props.color, speed = _props.speed, gap = _props.gap, thickness = _props.thickness, size = _props.size, className = _props.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSpinnerComponent, {
                    height: size,
                    width: size,
                    style: {
                        animationDuration: "".concat(this.speedSwitch(speed), "ms")
                    },
                    className: "__svg-spinner_circle ".concat(className),
                    role: "img",
                    viewBox: "0 0 32 32",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                        role: "presentation",
                        cx: 16,
                        cy: 16,
                        r: 14 - thickness / 2,
                        stroke: color,
                        fill: "none",
                        strokeWidth: thickness,
                        strokeDasharray: Math.PI * 2 * (11 - gap),
                        strokeLinecap: "round"
                    })
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return this.getSpinner();
            }
        }
    ]);
    return SpinnerComponent;
}(react.PureComponent);

SpinnerComponent.propTypes = {
    color: (prop_types_default()).string,
    thickness: prop_types_default().oneOf([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8
    ]).isRequired,
    gap: prop_types_default().oneOf([
        1,
        2,
        3,
        4,
        5
    ]).isRequired,
    speed: prop_types_default().oneOf([
        "fast",
        "slow"
    ]),
    size: (prop_types_default()).string.isRequired
};
SpinnerComponent.defaultProps = {
    color: "rgba(0,0,0,0.4)",
    gap: 4,
    thickness: 4,
    size: "1em"
};


/***/ }),

/***/ 84079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pricing_modal_signup_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/pages/pricing-page/pricing-modal-signup-component/pricing-modal-signup-component.scss.js


var modalSignup = new String(".modal-signup-container.jsx-d624ab9d3faa2301{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;font-weight:300;position:fixed;top:0;bottom:0;right:0;left:0;padding:0 16px;background-color:rgba(40,40,40,.94);z-index:".concat(z_index/* MODAL_BACKGROUND */.AE, "}.close-button.jsx-d624ab9d3faa2301{position:absolute;top:10px;right:10px;cursor:pointer;color:").concat(colors/* default.modal-signup-close-grey */.Z["modal-signup-close-grey"], ";fill:currentColor;svg{width:35px;height:35px}}.main-title.jsx-d624ab9d3faa2301{font-size:2.7rem;color:").concat(colors/* default.modal-signup-title-yellow */.Z["modal-signup-title-yellow"], ";text-align:center}.secondary-title.jsx-d624ab9d3faa2301{font-size:1.575rem;color:white;text-align:center;margin-top:8px;margin-bottom:8px}.signup-wrapper.jsx-d624ab9d3faa2301{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center}.bottom-part.jsx-d624ab9d3faa2301{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;margin-top:8px}.line.jsx-d624ab9d3faa2301{background-clip:content-box;width:60px;padding:14px 0;height:30px;background-color:white}.bottom-text.jsx-d624ab9d3faa2301{font-size:1rem;color:white;margin:0 10px;vertical-align:top;line-height:30px}"));
modalSignup.__hash = "d624ab9d3faa2301";

// EXTERNAL MODULE: ./components/core/signups/base-signup-form/signup-form-component.js + 2 modules
var signup_form_component = __webpack_require__(24494);
;// CONCATENATED MODULE: ./static/svg/close-circular.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgCloseCircular = function SvgCloseCircular(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        xmlSpace: "preserve",
        width: 512,
        height: 512,
        viewBox: "0 0 512 512"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        d: "M440 78.1C341.6-22.2 177.9-24.5 77.6 73.9s-101.8 261.3-3.3 361.5c98.4 100.3 262.1 100.9 362.4 2.5S538.4 178.4 440 78.1M319.6 370.2l-63.4-64.5-68.2 66.9c-13.2 13-26.4 16.8-45.8-.6-19.2-19.8-16.3-36.1-3.1-49.1l68.2-67-66.9-68.1c-13-13.2-15.8-29.8 2.1-47.4 16.6-16.3 34.6-14.7 47.6-1.5L257 207l64.4-63.3c13.2-13 33-20 51.2-1.4 24.4 24.9 7.2 41.8-.5 49.3L306 256.8l63.4 64.5c13 13.2 18 35.4 1.3 51.1-17.4 16.4-38.1 11-51.1-2.2"
    })));
};
/* harmony default export */ var close_circular = (SvgCloseCircular);

// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
;// CONCATENATED MODULE: ./components/pages/pricing-page/pricing-modal-signup-component/pricing-modal-signup-component.js











var PricingModalSignupComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(PricingModalSignupComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(PricingModalSignupComponent);
    function PricingModalSignupComponent() {
        (0,_class_call_check/* default */.Z)(this, PricingModalSignupComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(PricingModalSignupComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, closeModalCallback = _props.closeModalCallback, translate = _props.translate;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(modalSignup.__hash) + " " + "modal-signup-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            onClick: closeModalCallback,
                            className: "jsx-".concat(modalSignup.__hash) + " " + "close-button",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(close_circular, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(modalSignup.__hash) + " " + "main-title",
                            children: [
                                " ",
                                translate("pricingPage.signupModalTitle"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(modalSignup.__hash) + " " + "secondary-title",
                            children: [
                                " ",
                                translate("pricingPage.signupModalSecondaryTitle"),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(modalSignup.__hash) + " " + "signup-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(signup_form_component/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "jsx-".concat(modalSignup.__hash) + " " + "bottom-part",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(modalSignup.__hash) + " " + "line"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "jsx-".concat(modalSignup.__hash) + " " + "bottom-text",
                                    children: [
                                        " ",
                                        translate("pricingPage.signupModalStartFreeTrial"),
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "jsx-".concat(modalSignup.__hash) + " " + "line"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: modalSignup.__hash,
                            children: modalSignup
                        })
                    ]
                });
            }
        }
    ]);
    return PricingModalSignupComponent;
}(react.PureComponent);
/* harmony default export */ var pricing_modal_signup_component = ((0,generic_config_context/* withGenericConfig */.P)(PricingModalSignupComponent));


/***/ })

}]);